// The meeting-based intake flow (Role Setup upload, Intake Call scheduling, My Meetings) is retired: hiring managers
// create jobs with Jessica from My Requisitions. Its screens are hidden, not deleted — existing jobs still open from
// the View icon, and the backend keeps existing meetings readable. Set to true only to bring the old screens back.
export const LEGACY_MEETINGS = false;
